import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-delete',
	path: '/secure/admin/DeleteNotification([!%]?[\\w]*).jspa',
};
